import { PropsWithChildren, PureComponent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormField } from '@enterprise/common';
import { SpotSelectBox, SpotSelectOption } from '@enterprise/spot';
import { AnalyticsAccessEntity } from '../../../../core/entity/AnalyticsAccessEntity';
import i18n from '../../../../i18n';

interface PricingTierFormControlProps {
    /** Catalog rows with `type === PRICING_TIER`. */
    pricingTiers: AnalyticsAccessEntity[];
    disabled?: boolean;
}

export class PricingTierFormControl extends PureComponent<PropsWithChildren<PricingTierFormControlProps>> {
    render() {
        const { pricingTiers, disabled = false } = this.props;
        return (
            <Row>
                <Col xs={5}>
                    <FormField
                        name="pricingTierId"
                        parse={(id: string) => (id ? Number(id) : undefined)}
                        format={(value) => (value != null && value !== ('' as any) ? String(value) : '')}
                    >
                        {({ input }) => (
                            <SpotSelectBox
                                {...input}
                                disabled={disabled}
                                placeholder={i18n.t('common:pleaseSelect', 'Please select')}
                                data-automation-id={'pricingTier'}
                            >
                                {pricingTiers.map((item) => (
                                    <SpotSelectOption key={item.id} value={item.id}>
                                        {item.name}
                                    </SpotSelectOption>
                                ))}
                            </SpotSelectBox>
                        )}
                    </FormField>
                </Col>
            </Row>
        );
    }
}
